<template>
  <div class="client-permissions mt-5" style="grid-column: span 6">
    <div class="flex items-center justify-between">
      <label>{{ $t("customPermissions") }}</label>
      <vs-switch v-model="custom" @input="emit" />
    </div>
    <p class="text-sm mt-2" v-if="!custom">{{ $t("defaultPermissionsHint") }}</p>
    <div v-else class="mt-3 flex flex-col">
      <vs-checkbox
        v-for="permission in permissionsList"
        :key="permission"
        v-model="permissions[permission]"
        @input="emit"
        class="remember m-0 mt-2"
        >{{ $t("permission_" + permission) }}</vs-checkbox
      >
    </div>
  </div>
</template>

<script>
// v-model value: { custom_permissions: Boolean, permissions: { [permission]: Boolean } }
export const PERMISSIONS = [
  "balances",
  "integrations",
  "employees",
  "supply_missions",
  "price_change_requests",
];

export default {
  name: "client-permissions-form",
  props: {
    value: {
      type: Object,
      default: () => ({ custom_permissions: false, permissions: {} }),
    },
  },
  data() {
    const permissions = {};
    PERMISSIONS.forEach((permission) => {
      permissions[permission] = !!(this.value.permissions || {})[permission];
    });
    return {
      permissionsList: PERMISSIONS,
      custom: !!this.value.custom_permissions,
      permissions,
    };
  },
  methods: {
    emit() {
      this.$emit("input", {
        custom_permissions: this.custom,
        permissions: { ...this.permissions },
      });
    },
  },
};
</script>
